const items = {
  "blog.overview": "overview",
  "blog.palicanon": "palicanon",
};

export default items;
